import Markdown from 'react-markdown'
import TextField from '@mui/material/TextField';
import skillsJson from './data/vaardigheden.json';

let skills = {};
for (let i = 0; i < skillsJson.length; i++) {
    let skillConfig = skillsJson[i];
    skills[skillConfig.naam] = require(`./data/${skillConfig.file}`);
}

// [WIP] General function to check if 'something' is defined empty
export function isEmpty(obj) {
    // undefined or null objects
    if (obj === undefined || obj === null) {
        return true;
    }

    // array check
    if (Array.isArray(obj) && obj.length === 0) {
        return true;
    }

    // string check
    if (typeof obj === 'string' && obj.trim().length === 0) {
        return true;
    }

    return false;
}

export function getConfigText(id, label) {
    let el = skills[id];
    return el[label] ?? null;
}

export function getExcerciseText(id, excerciseId, label) {
    let excercies = getConfigText(id, "oefeningen");
    return excercies[excerciseId][label] ?? null;
}

export function getExcerciseChoiceConfig(id, excerciseId, choice) {
    let choiceArray = getExcerciseText(id, excerciseId, 'keuze_' + choice.toLowerCase())
    return choiceArray ?? [];
}

export function newLineParser(str) {
    if(typeof str !== 'string') {
        return str;
    }
    return str.split("<br/>").map((c, i) => (
        <Markdown className="markdowntext">{c}</Markdown>
    ))
}

export function skillNames() {
    return Object.keys(skills);
}

export function isIntroException(pageId) {
    //Object.keys(skills)[0] gets the id of the 'introductie' module
    return pageId == Object.keys(skills)[0];
}

